import { environment } from '../environments/environment';

import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AdvertBarComponent } from './components/advert-bar/advert-bar.component';
import { MenuComponent } from './components/menu/menu.component';
import { FooterComponent } from './components/footer/footer.component';
import { HomeComponent } from './pages/home/home.component';
import { SlickModule } from 'ngx-slick';
import { CourseTileComponent } from './components/course-tile/course-tile.component';
import { CategoryTileComponent } from './components/category-tile/category-tile.component';
import { ReviewTileComponent } from './components/review-tile/review-tile.component';
import { NewsletterComponent } from './components/newsletter/newsletter.component';
import { CoursesComponent } from './pages/courses/courses.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { CategoriesComponent } from './pages/categories/categories.component';
import { CategoryComponent } from './pages/category/category.component';
import { StarsComponent } from './components/stars/stars.component';
import { CourseComponent } from './pages/course/course.component';
import { SafePipe } from './pipes/safe.pipe';
import { VideoComponent } from './components/video/video.component';
import { RegisterComponent } from './pages/register/register.component';
import { ErrorComponent } from './components/error/error.component';
import { LoginComponent } from './pages/login/login.component';
import { AccountComponent } from './pages/account/account.component';
import { TokenInterceptor } from './lib/token-interceptor';
import { SuccessComponent } from './components/success/success.component';
import { RecoverComponent } from './pages/recover/recover.component';
import { CompleteRecoveryComponent } from './pages/complete-recovery/complete-recovery.component';
import { ProgressCircleComponent } from './components/progress-circle/progress-circle.component';
import {RoundProgressModule} from 'angular-svg-round-progressbar';
import { Module as StripeModule } from "stripe-angular";
import { StripeComponent } from './pages/stripe/stripe.component';
import { PricingComponent } from './pages/pricing/pricing.component';
import { BasketComponent } from './pages/basket/basket.component';
import { CheckoutComponent } from './pages/checkout/checkout.component';
import { OrderComponent } from './pages/account/orders/order/order.component';
import { OrdersComponent } from './pages/account/orders/orders.component';
import { MycoursesComponent } from './pages/mycourses/mycourses.component'
import { CPDtime } from './pipes/cpdtime.pipe';
import { CPDtimeonly } from './pipes/cpdtimeonly.pipe';
import { CPDPrice } from './pipes/cpdprice.pipe';

import { SecondsToMins } from './pipes/secondstomins.pipe';
import { PlaybackBarComponent } from './components/playback-bar/playback-bar.component';
import { MyReviewComponent } from './components/my-review/my-review.component';
import { ReviewComponent } from './components/review/review.component';
import { QuizComponent } from './components/quiz/quiz.component';
import { TermsComponent } from './pages/terms/terms.component';
import { PrivacyComponent } from './pages/privacy/privacy.component';
import { CookiesComponent } from './pages/cookies/cookies.component';
import { BlogComponent } from './pages/blog/blog.component';
import { BlogArticleComponent } from './pages/blog-article/blog-article.component';
import { CPD } from './pipes/cpd.pipe';
import { VideoOlReviewComponent } from './components/video-ol-review/video-ol-review.component';
import { SubscribeComponent } from './pages/subscribe/subscribe.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {MatDialogModule} from '@angular/material/dialog';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { CancelSubscriptionComponent } from './components/modals/cancel-subscription/cancel-subscription.component';
import { PracticeComponent } from './pages/practice/practice.component';
import { CreatePracticeComponent } from './components/modals/create-practice/create-practice.component';
import { GnProgressCircleComponent } from './components/gn-progress-circle/gn-progress-circle.component';
import { AddMemberToPracticeComponent } from './components/modals/add-member-to-practice/add-member-to-practice.component';
import { SearchComponent } from './pages/search/search.component';
import { ProgrammesComponent } from './pages/programmes/programmes.component';
import { ProgrammeComponent } from './pages/programmes/programme/programme.component';
import { AddMemberProgrammeComponent } from './components/modals/add-member-programme/add-member-programme.component';
import { CoursePickerComponent } from './components/modals/course-picker/course-picker.component';
import { NewProgrammeComponent } from './components/modals/new-programme/new-programme.component';
import { DocumentsComponent } from './components/documents/documents.component';
import { StreamTileComponent } from './components/stream-tile/stream-tile.component';
import { FilterCourseComponent } from './components/filter-course/filter.component';
import { FilterStreamComponent } from './components/filter-stream/filter.component';
import { StreamComponent } from './pages/stream/stream.component';
import { AddToBasketComponent } from './components/add-to-basket/add-to-basket.component';
import { AboutComponent } from './pages/about/about.component';
import { FaqsComponent } from './pages/faqs/faqs.component';
import { HeroComponent } from './components/hero/hero.component';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { ContactComponent } from './pages/contact/contact.component';
import { SupportComponent } from './pages/support/support.component';
import { TutorsComponent } from './pages/tutors/tutors.component';
import { PressComponent } from './pages/press/press.component';
import { FooterAdvertsComponent } from './components/footer-adverts/footer-adverts.component';
import { MatFormFieldModule, MatInputModule, MatSelectModule, MatSnackBarModule, MatDatepickerModule, MatNativeDateModule, MatRadioModule, MatToolbarModule } from '@angular/material';
import { SupportersComponent } from './pages/supporters/supporters.component';
import { BlogPostTileComponent } from './components/blog-post-tile/blog-post-tile.component';
import { WatchingComponent } from './pages/watching/watching.component';
import { WatchlistComponent } from './pages/watchlist/watchlist.component';
import { CourseProgrammeComponent } from './components/modals/course-programme/course-programme.component';
import { PracticeContentComponent } from './pages/practice/practice-content/practice-content.component';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { PracticeConentQuizComponent } from './pages/practice/practice-content/practice-conent-quiz/practice-conent-quiz.component';
import { PracticeContentLessonsComponent } from './pages/practice/practice-content/practice-content-lessons/practice-content-lessons.component';
import { AddCoursesComponent } from './components/modals/add-courses/add-courses.component';
import { TutorComponent } from './pages/tutors/tutor/tutor.component';
import { SupporterComponent } from './pages/supporters/supporter/supporter.component';
import { StudentsComponent } from './pages/students/students.component';
import { StudentComponent } from './pages/students/student/student.component';
import { VerifyComponent } from './pages/account/verify/verify.component';
import { HistoryComponent } from './pages/account/history/history.component';
import { AddMentorToPracticeComponent } from './components/modals/add-mentor-to-practice/add-mentor-to-practice.component';
import { SeatscriptionComponent } from './pages/seatscription/seatscription.component';
import { AddMentorToMemberComponent } from './components/modals/add-mentor-to-member/add-mentor-to-member.component';
import { DataTableComponent } from './components/data-table/data-table.component';
import { PaymentMethodsComponent } from './pages/account/payment-methods/payment-methods.component';
import { BenefitsBannerComponent } from './components/benefits-banner/benefits-banner.component';
import { TrainingProgrammesComponent } from './pages/training-programmes/training-programmes.component';
import { StreamProgrammeComponent } from './components/modals/stream-programme/stream-programme.component';
import { PracticeContentDocumentsComponent } from './pages/practice/practice-content/practice-content-documents/practice-content-documents.component';
import { DocumentUploaderComponent } from './components/modals/document-uploader/document-uploader.component';
import { RegisterSuccessComponent } from './pages/register/register-success/register-success.component';
import { FreevetComponent } from './pages/freevetcpd/freevet.component';
import { PaginationComponent } from './components/pagination/pagination.component';
import { DataListComponent } from './components/data-list/data-list.component';
import { MembershipBannerComponent } from './components/membership-banner/membership-banner.component';

@NgModule({
  entryComponents:[
    ErrorComponent,
    SuccessComponent,
    CancelSubscriptionComponent,
    CreatePracticeComponent,
    AddMemberToPracticeComponent,
    AddMentorToPracticeComponent,
    AddMemberProgrammeComponent,
    CoursePickerComponent,
    NewProgrammeComponent,
    CourseProgrammeComponent,
    AddCoursesComponent,
    AddMentorToMemberComponent,
    StreamProgrammeComponent,
    DocumentUploaderComponent
  ],
  declarations: [
    AppComponent,
    AdvertBarComponent,
    MenuComponent,
    FooterComponent,
    HomeComponent,
    CourseTileComponent,
    CategoryTileComponent,
    ReviewTileComponent,
    NewsletterComponent,
    CoursesComponent,
    CategoriesComponent,
    CategoryComponent,
    StarsComponent,
    CourseComponent,
    SafePipe,
    VideoComponent,
    RegisterComponent,
    ErrorComponent,
    LoginComponent,
    AccountComponent,
    SuccessComponent,
    RecoverComponent,
    CompleteRecoveryComponent,
    ProgressCircleComponent,
    StripeComponent,
    PricingComponent,
    BasketComponent,
    CheckoutComponent,
    OrderComponent,
    OrdersComponent,
    MycoursesComponent,
    CPD,
    CPDtime,
    CPDtimeonly,
    SecondsToMins,
    CPDPrice,
    PlaybackBarComponent,
    MyReviewComponent,
    ReviewComponent,
    QuizComponent,
    TermsComponent,
    PrivacyComponent,
    CookiesComponent,
    BlogComponent,
    BlogArticleComponent,
    VideoOlReviewComponent,
    SubscribeComponent,
    CancelSubscriptionComponent,
    PracticeComponent,
    CreatePracticeComponent,
    GnProgressCircleComponent,
    AddMemberToPracticeComponent,
    SearchComponent,
    ProgrammesComponent,
    ProgrammeComponent,
    AddMemberProgrammeComponent,
    CoursePickerComponent,
    NewProgrammeComponent,
    DocumentsComponent,
    StreamTileComponent,
    StreamComponent,
    AddToBasketComponent,
    FilterCourseComponent,
    FilterStreamComponent,
    StreamComponent,
    AboutComponent,
    FaqsComponent,
    HeroComponent,
    BreadcrumbComponent,
    ContactComponent,
    SupportComponent,
    TutorsComponent,
    PressComponent,
    FooterAdvertsComponent,
    SupportersComponent,
    BlogPostTileComponent,
    WatchingComponent,
    WatchlistComponent,
    CourseProgrammeComponent,
    PracticeContentComponent,
    PracticeConentQuizComponent,
    PracticeContentLessonsComponent,
    AddCoursesComponent,
    TutorComponent,
    SupporterComponent,
    StudentsComponent,
    StudentComponent,
    VerifyComponent,
    HistoryComponent,
    AddMentorToPracticeComponent,
    SeatscriptionComponent,
    AddMentorToMemberComponent,
    DataTableComponent,
    PaymentMethodsComponent,
    BenefitsBannerComponent,
    TrainingProgrammesComponent,
    StreamProgrammeComponent,
    PracticeContentDocumentsComponent,
    DocumentUploaderComponent,
    RegisterSuccessComponent,
    FreevetComponent,
    PaginationComponent,
    DataListComponent,
    MembershipBannerComponent
  ],
  imports: [
    CKEditorModule,
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    MatDialogModule,
    MatCheckboxModule,
    FormsModule,
    ReactiveFormsModule,
    RoundProgressModule,
    SlickModule.forRoot(),
    StripeModule.forRoot(),
    BrowserAnimationsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatSnackBarModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatRadioModule,
    MatToolbarModule
  ],
  providers: [
    {provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
